import { MenuItem, Select } from "@mui/material";
import { getLang, setLang, LANGS } from "../../../../config/localisation";

// Выпадающий список выбора языка интерфейса (Рус/Uzb/Eng).
const LanguageSelect = ({ sx = {}, onLight = false }) => {
  const color = onLight ? "#2C2799" : "inherit";
  return (
    <Select
      value={getLang()}
      onChange={(e) => setLang(e.target.value)}
      variant="standard"
      disableUnderline
      sx={{
        fontSize: 14,
        color,
        "& .MuiSelect-select": { py: 0, pr: "20px !important" },
        "& .MuiSvgIcon-root": { color },
        ...sx,
      }}
    >
      {LANGS.map((l) => (
        <MenuItem key={l.code} value={l.code} sx={{ fontSize: 14 }}>
          {l.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default LanguageSelect;
